import { Partner } from "@dashboard/common/types";
import { fetchUpdateUserDetail } from "@dashboard/modules/profile/fetchers/user-detail.fetchers";
import { getApiUrl } from "@dashboard/common/utils";
import { decamelizeKeys } from "humps";
import { parseUserDetailResponse } from "../utils/user-detail.utils";

export const fetchUpdateUserDetailForDelivery = async (
  token: string,
  data: Partner
): Promise<Partner> => {
  const response = await fetch(`${getApiUrl()}/api/ms/user/user-detail`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "X-API-VERSION": "2",
    } as { [key: string]: string },
    body: JSON.stringify(decamelizeKeys(data)),
  });
  if (response.status === 200) {
    const responseJson = await response.json();
    return parseUserDetailResponse(responseJson);
  }
  throw new Error("Failed to update user detail");
};

export { fetchUpdateUserDetail };
